var React = require('react');

function IconFolderInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0837 5.04169V7.79169C10.0837 9.62502 9.62533 10.0834 7.79199 10.0834H3.20866C1.37533 10.0834 0.916992 9.62502 0.916992 7.79169V3.20835C0.916992 1.37502 1.37533 0.916687 3.20866 0.916687H3.89616C4.58366 0.916687 4.73491 1.11835 4.99616 1.46669L5.68366 2.38335C5.85783 2.61252 5.95866 2.75002 6.41699 2.75002H7.79199C9.62533 2.75002 10.0837 3.20835 10.0837 5.04169Z","stroke":"#31373E","strokeMiterlimit":"10"}));
}

IconFolderInline.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = IconFolderInline;

IconFolderInline.default = IconFolderInline;
